import { apiClient } from './client';

export interface Patient {
  id: number;
  first_name: string;
  last_name: string;
  date_of_birth: string;
}

export interface PatientEvent {
  id: string;
  type: string;
  title: string;
  time: string;
  color: string;
  meal_type?: string;
  medication_id?: number;
  medication_time_id?: number;
}

export async function getPatientById(patientId: number): Promise<Patient> {
  const response = await apiClient.get<Patient>(`/patients/${patientId}`);
  return response.data;
}

export async function getPatientEvents(patientId: number): Promise<PatientEvent[]> {
  const response = await apiClient.get<PatientEvent[]>(`/patients/${patientId}/events`);
  return response.data;
}

export interface PatientQRToken {
  token: string;
}

export async function getPatientQRToken(patientId: number): Promise<PatientQRToken> {
  const response = await apiClient.get<PatientQRToken>(`/patients/${patientId}/qr-token`);
  return response.data;
}
